import { render, staticRenderFns } from "./ModalConfirmationCourse.vue?vue&type=template&id=55ecfbda&scoped=true"
import script from "./ModalConfirmationCourse.vue?vue&type=script&lang=js"
export * from "./ModalConfirmationCourse.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmationCourse.vue?vue&type=style&index=0&id=55ecfbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ecfbda",
  null
  
)

export default component.exports